<template>
	<div class="banner-sliders">
		<div class="row">
			<div class="cols-sm-12">
				<div id="carouselExampleCaptions" class="carousel slide" data-bs-ride="carousel">
					<div class="carousel-inner">
						<div class="carousel-item active" v-for="items in data.banner" :key="items" @mouseover="accebility(items.title)"> 
							<img v-bind:src="imagesBanner(items)" class="d-block w-100 image-slide">
							<div class="carousel-caption">
								<div class="row">
									<div class="col-12">
										<!-- <h5 class="title-slider-item" @click="lihat(items)" :title="items.title">{{ limitTitle(items.title, 120) }}</h5>
										<p class="desc-slider-item">{{ limitTitle(items.description, 180) }}</p> -->
                      <a :href="lihat(items)" :title="items.title">
                        <h5 class="title-slider-item">{{ limitTitle(items.title, 50) }}</h5>                                    
                      </a>
                        <p class="desc-slider-item">{{ limitTitle(items.description, 180) }}</p>
									</div> 
									<div class="col-4">
										<p class="tanggal-slider-item">{{ toDate(items.created_at) }}</p>
									</div>
									<div class="col-7" align="right">
                    <a :href="lihat(items)"><button class="button-lihat">Baca Selengkapnya</button></a>  
									</div>
									<div class="col-1"></div>
								</div>
							</div>
						</div>
					</div>
					<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="prev"> <span class="carousel-control-prev-icon" aria-hidden="true"></span> <span class="visually-hidden">Previous</span> </button>
					<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleCaptions" data-bs-slide="next"> <span class="carousel-control-next-icon" aria-hidden="true"></span> <span class="visually-hidden">Next</span> </button>
				</div>
			</div>
		</div>
	</div>
</template>
    
<script>
import axios from 'axios';
export default {
  name: 'BannerslidersComponents',
  components: {
       
  },
  data(){
    return{
    baseUrl:this.$store.state.baseUrl,
		baseApi:this.$store.state.apiUrl,
		data:[],
		isAccebility:this.$store.state.isAccebility
    }
  },
  mounted(){

	axios.get(`${this.baseApi}/api/v2/satudata/banner-slider`).then(res=>{
      this.data = res.data
    })
  },
  methods:{
	limitTitle (string = '', limit = 0) {
      if(string){
        let next = ''
        if(string.length>limit){
          next = ' ...'
        }
        return string.substring(0, limit) + next
      }
    },
	imagesBanner(items){
        return this.baseApi+'/uploads/img/700/'+items.path_cover
    },
	// toDate(items){
    //     let date = new Date(items)
    //     let month = date.getMonth()+1
    //     return date.getFullYear()+'-'+month+'-'+date.getDay()
    // },
	/*eslint no-mixed-spaces-and-tabs: ["error", "smart-tabs"]*/
	toDate(items){
      let dates = new Date(items)
      //let month = ("0" + (dates.getMonth() + 1)).slice(-2)
	  let month = dates.toLocaleString("id-ID",{month:"long"})
      let date = ("0" + (dates.getDay() + 1)).slice(-2)
      return date+' '+month+' '+dates.getFullYear()
    //   return date+'-'+month+'-'+dates.getFullYear()
    },
	accebility(voice){
        if(this.isAccebility.modeSuara){
			let msg = new SpeechSynthesisUtterance();
			let voices = window.speechSynthesis.getVoices()
			msg.voice = voices[160];
			msg.text = voice;
			msg.volume = 10;
			msg.rate = 1;
			msg.pitch = 1;
			window.speechSynthesis.cancel();
			window.speechSynthesis.speak(msg);
        }
    },

  lihat(items) {
        switch (items.category) {
            case "artikel":
              return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
           
            case "infografis":
              return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
          
            case "analisis":
              return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
          
            case "hasil-survei":
              return this.baseUrl + "/statistik-sektoral/detail?kategori=" + items.category + "&page_url=" + items.page_url;
            
        }
  }
  }
}
</script>
    